// extracted by mini-css-extract-plugin
export default {"box":"ServiceHome_box__rFQu8","heading":"ServiceHome_heading__V-d2f","text":"ServiceHome_text__CmsRT","to":"ServiceHome_to__RLW1w","img":"ServiceHome_img__6tceF"};